import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const productRoadmap = {
    "id": "c03n1i",
    "name": "Product Roadmap",
    "img": "/app/static/templates/product/roadmap.jpg",
    "description": "Quarterly product planning template with timeline.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const feedback = {
    "id": "6sdk2u",
    "name": "User Feedback",
    "img": "/app/static/templates/product/feedback.jpg",
    "description": "Track two-way communication with users and feedback response.",
    systemType: ProjectSystemType.BACKLOG,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const issues = {
    "id": "UaaYVb",
    "name": "Issue Tracker",
    "img": "/app/static/templates/it/issue-tracking.jpg",
    "description": "Workflows to track and resolve product issues.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const agile = {
    "id": "ClUpUi",
    "name": "Agile Product Dev.",
    "img": "/app/static/templates/product/agile.jpg",
    "description": "Pre-configured structure to manage backlog and run sprints.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const featureRequests = {
    "id": "zLwi8t",
    "name": "Feature Requests",
    "img": "/app/static/templates/product/feature-requests.jpg",
    "description": "Convenient feature request tracker to prioritize and execute.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const productBacklog = {
    "id": "Hwoys8",
    "name": "Product Backlog",
    "img": "/app/static/templates/product/product-backlog.jpg",
    "description": "Pre-configured space to create and manage feature backlog.",
    systemType: ProjectSystemType.BACKLOG,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const userStoryMapping = {
    "id": "pKvr4v",
    "name": "User Story Mapping",
    "img": "/app/static/templates/product/user-story.jpg",
    "description": "Record and assign user stories to sprints with this template.",
    systemType: ProjectSystemType.BACKLOG,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};



export default {
    id: 'product-management',
    name: "Product Management",
    items: [

        productRoadmap,
        agile,
        productBacklog,

        feedback,
        issues,

        featureRequests,

        userStoryMapping
    ]
};